import { createFileRoute } from '@tanstack/react-router'

import { PaginaFrango } from '@/features/frango/pagina'

export const Route = createFileRoute('/$perfil/frango/')({
  component: Tela,
})

function Tela() {
  const { perfil } = Route.useParams()
  return <PaginaFrango perfil={perfil} />
}
